// This api will come in the next version
import { AuthConfig } from 'angular-oauth2-oidc';
import { configuration } from '../../../environments/config'


export const authPasswordFlowConfig: AuthConfig = {
  // Url of the Identity Provider
  issuer: configuration.issuer,

  tokenEndpoint: configuration.tokenEndpoint,
  
  userinfoEndpoint: configuration.userinfoEndpoint,

  // URL of the SPA to redirect the user to after login
  redirectUri: window.location.origin + '/index.html',

  // URL of the SPA to redirect the user after silent refresh
  silentRefreshRedirectUri: window.location.origin + '/index.html',

  //URL redirection for logout
  loginUrl : window.location.origin + '/login.html',

  // The SPA's id. The SPA is registerd with this id at the auth-server
  clientId: 'fr.obexto.b2b.extranet',

  dummyClientSecret: configuration.dummyClientSecret,

  // set the scope for the permissions the client should request
  // The first three are defined by OIDC. The 4th is a usecase-specific one
  scope: 'obexto.user offline_access ',

  showDebugInformation: true,

  oidc: false
};
